export default __webpack_public_path__ + "static/media/logo-white.ae50914a.png";